import {
  Activity,
  BookOpen,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  FileText,
  Gavel,
  House,
  Layers,
  LayoutGrid,
  MessageCircleQuestion,
  Settings,
  Shapes,
  Shield,
  Target,
  TrendingUp,
  Trophy,
  Upload,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { NavKey } from '@/lib/nav';

/**
 * A mark for each destination, for the bottom bar and the collapsed rail.
 *
 * Typed against `NavKey` rather than a loose record, so adding a screen to the
 * navigation and forgetting its icon is a compile error rather than a blank
 * square on a phone.
 *
 * Icons are a second channel beside the label, never a replacement for one:
 * the only place a label is dropped is the collapsed desktop rail, which is
 * opt-in and remembered, and even there the name stays in the title and for a
 * screen reader.
 */
export const NAV_ICONS: Record<NavKey, LucideIcon> = {
  dashboard: House,
  plan: CalendarRange,
  sessions: ClipboardList,
  exercises: Shapes,
  calendar: CalendarDays,
  matches: Trophy,
  formations: LayoutGrid,
  squad: Users,
  register: ClipboardCheck,
  development: TrendingUp,
  load: Activity,
  objectives: Target,
  decisions: Gavel,
  blocks: Layers,
  reports: FileText,
  teams: Shield,
  seasons: CalendarClock,
  import: Upload,
  settings: Settings,
  guide: BookOpen,
  ask: MessageCircleQuestion,
};
